module.exports = __webpack_public_path__ + "static/media/sourcesanspro-lightitalic-webfont.03f9a24f.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/source-sans-pro/sourcesanspro-lightitalic-webfont.ttf
// module id = 505
// module chunks = 0